import { useState } from 'react';
import { Absensi } from '../model/Absensi';
import { fetchPutAbsensiRecord } from '../controller/dashboard/Absensi';

export default function FormAbsensiModal({ absensiDetail, setShowFormModal, onPostState } : {
  absensiDetail: Absensi | null,
  setShowFormModal: (v: boolean) => void,
  onPostState: () => void
}){
  const [formData, setFormData] = useState<Absensi | null>(() => absensiDetail);
  const [saving, setSaving] = useState(false);

  if(!formData) return null;

  const handleSubmit = async () => {
    setSaving(true);
    const payload: any = {
      jam_masuk: formData.jam_masuk,
      jam_keluar: formData.jam_keluar,
      status: formData.status
    };
    await fetchPutAbsensiRecord({ id: formData.id, payload });
    setSaving(false);
    setShowFormModal(false);
    onPostState();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={() => setShowFormModal(false)} />
      <div className="relative w-11/12 max-w-lg rounded-2xl bg-white p-6 shadow-lg">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">Edit Absensi</h3>
          <button onClick={() => setShowFormModal(false)} className="text-gray-500">✕</button>
        </div>

        <div className="space-y-3">
          <div>
            <label className="block text-sm text-gray-600">Tanggal</label>
            <input type="date" value={formData.tanggal?.split(' ')[0] ?? ''} onChange={(e) => setFormData({...formData, tanggal: `${e.target.value} ${formData.tanggal?.split(' ')[1] ?? '00:00:00'}`})} className="w-full border px-3 py-2 rounded" disabled />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm text-gray-600">Jam Masuk</label>
              <input type="time" value={formData.jam_masuk ? new Date(formData.jam_masuk).toLocaleTimeString('en-GB').slice(0,5) : ''} onChange={(e) => setFormData({...formData, jam_masuk: `${formData.tanggal.split(' ')[0]} ${e.target.value}:00`})} className="w-full border px-3 py-2 rounded" />
            </div>
            <div>
              <label className="block text-sm text-gray-600">Jam Keluar</label>
              <input type="time" value={formData.jam_keluar ? new Date(formData.jam_keluar).toLocaleTimeString('en-GB').slice(0,5) : ''} onChange={(e) => setFormData({...formData, jam_keluar: `${formData.tanggal.split(' ')[0]} ${e.target.value}:00`})} className="w-full border px-3 py-2 rounded" />
            </div>
          </div>

          <div>
            <label className="block text-sm text-gray-600">Status </label>
            <select value={formData.status ?? ''} onChange={(e) => setFormData({...formData, status: e.target.value})} className="w-full border px-3 py-2 rounded">
              <option value="">Pilih Status</option>
              <option value="tepat">Hadir</option>
              <option value="tepat">WFH</option>
              <option value="terlambat">Terlambat</option>
              <option value="izin">Izin</option>
              <option value="sakit">Sakit</option>
              <option value="alfa">Alpha</option>
              <option value="pulang_tanpa_izin">Pulang Tanpa Izin</option>
              <option value="dinas_luar">Dinas Luar</option>
              <option value="cuti">Cuti</option>
            </select>
          </div>

          <div className="flex justify-end gap-2">
            <button className="px-4 py-2 rounded bg-gray-100" onClick={() => setShowFormModal(false)}>Batal</button>
            <button className="px-4 py-2 rounded bg-blue-600 text-white" onClick={handleSubmit} disabled={saving}>{saving ? 'Menyimpan...' : 'Simpan'}</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export function FormGetListWages() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" />
      <div className="relative w-11/12 max-w-lg rounded-2xl bg-white p-6 shadow-lg">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">Edit Absensi</h3>
          <button className="text-gray-500">✕</button>
        </div>

        <div className="space-y-3">
          <div>
            <label className="block text-sm text-gray-600">Tanggal</label>
            <input type="date" className="w-full border px-3 py-2 rounded" />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm text-gray-600">Jam Masuk</label>
              <input type="time" className="w-full border px-3 py-2 rounded" />
            </div>
            <div>
              <label className="block text-sm text-gray-600">Jam Keluar</label>
              <input type="time" className="w-full border px-3 py-2 rounded" />
            </div>
          </div>

          <div>
            <label className="block text-sm text-gray-600">Tipe Aktivitas</label>
            <input type="text" className="w-full border px-3 py-2 rounded" />
          </div>

          <div>
            <label className="block text-sm text-gray-600">Detail Aktivitas</label>
            <textarea className="w-full border px-3 py-2 rounded" rows={4} />
          </div>

          <div>
            <label className="block text-sm text-gray-600">Status</label>
            <select className="w-full border px-3 py-2 rounded">
              <option value="">Pilih Status</option>
              <option value="hadir">hadir</option>
              <option value="izin">izin</option>
              <option value="alpha">alpha</option>
            </select>
          </div>

          <div className="flex justify-end gap-2">
            <button className="px-4 py-2 rounded bg-gray-100">Batal</button>
            <button className="px-4 py-2 rounded bg-blue-600 text-white">Simpan</button>
            {/* <button className="px-4 py-2 rounded bg-blue-600 text-white" onClick={handleSubmit} disabled={saving}>{saving ? 'Menyimpan...' : 'Simpan'}</button> */}
          </div>
        </div>
      </div>
    </div>
  )
} 
